import { render, staticRenderFns } from "./add-coupon.vue?vue&type=template&id=bf381c92&scoped=true"
import script from "./add-coupon.vue?vue&type=script&lang=js"
export * from "./add-coupon.vue?vue&type=script&lang=js"
import style0 from "./add-coupon.vue?vue&type=style&index=0&id=bf381c92&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf381c92",
  null
  
)

export default component.exports